import { useState } from "react";
import { Copy, Mail, X } from "lucide-react";
import { CONTACT_EMAIL } from "../data/siteData";
import { useLang } from "../i18n";

export const EmailReveal = ({ testId }) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const { t } = useLang();

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(CONTACT_EMAIL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {}
  };

  return (
    <>
      <button
        data-testid={`${testId}-button`}
        onClick={() => setOpen(true)}
        className="mt-2 inline-flex items-center gap-2 font-mono-tech text-sm tracking-wider text-red-500 hover:text-red-400 border border-zinc-800 hover:border-red-600 px-4 py-2.5 transition-colors duration-300"
      >
        <Mail size={15} /> {t.contact.cta}
      </button>

      {open && (
        <div
          data-testid="email-modal"
          className="fixed inset-0 z-[80] flex items-center justify-center bg-black/80 backdrop-blur-sm px-5"
          onClick={() => setOpen(false)}
        >
          <div
            className="relative bg-[#121216] border border-zinc-800 p-8 max-w-sm w-full shadow-[0_8px_40px_rgba(0,0,0,0.8)]"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              data-testid="email-modal-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
              className="absolute top-3 right-3 text-zinc-500 hover:text-white transition-colors"
            >
              <X size={18} />
            </button>
            <p className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-zinc-500">{t.contact.title}</p>
            <p data-testid="email-modal-address" className="font-mono-tech text-base text-red-500 tracking-wider mt-3 break-all">
              {CONTACT_EMAIL}
            </p>
            <p className="text-sm text-zinc-400 mt-3 leading-relaxed">{t.contact.note}</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                data-testid="email-modal-mailto"
                href={`mailto:${CONTACT_EMAIL}`}
                className="inline-flex items-center gap-2 font-mono-tech text-xs tracking-[0.2em] uppercase bg-red-600 hover:bg-red-700 text-white px-4 py-2.5 transition-colors duration-300"
              >
                <Mail size={14} /> {t.contact.open}
              </a>
              <button
                data-testid="email-modal-copy"
                onClick={copy}
                className="inline-flex items-center gap-2 font-mono-tech text-xs tracking-[0.2em] uppercase border border-zinc-700 hover:border-red-600 text-zinc-300 hover:text-white px-4 py-2.5 transition-colors duration-300"
              >
                <Copy size={14} /> {copied ? t.contact.copied : t.contact.copy}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
